export var appConfig = {
  insaServiceAddress: "https://webportal.kestrel.ch/InsaWebApi/api",
  authServiceAddress: "https://webportal.kestrel.ch/InsaWebApi",
  pivotViewerServiceAddress: "https://webportal.kestrel.ch/InsaWebApi"
}


// WEBPACK FOOTER //
// ./insa-css/insa-clients/Kestrel/insaweb.service.config.ts